var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 9.91667V3.41667C19.6667 2.84203 19.4384 2.29093 19.0321 1.8846C18.6257 1.47827 18.0746 1.25 17.5 1.25H3.41667C2.84203 1.25 2.29093 1.47827 1.8846 1.8846C1.47827 2.29093 1.25 2.84203 1.25 3.41667V18.5833C1.25 19.158 1.47827 19.7091 1.8846 20.1154C2.29093 20.5217 2.84203 20.75 3.41667 20.75H8.83333",
    stroke: "#0A4468",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02083 14.25H8.83333",
    stroke: "#0A4468",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9583 12.9695V16.4166",
    stroke: "#0A4468",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 21.8333H13.3021C12.9788 21.8333 12.6689 21.7049 12.4403 21.4764C12.2117 21.2478 12.0833 20.9378 12.0833 20.6146V15.9476C12.0835 15.6549 12.1429 15.3653 12.2577 15.0961L12.8503 13.7094C12.9443 13.4899 13.1006 13.3027 13.2999 13.1712C13.4992 13.0397 13.7328 12.9695 13.9716 12.9695H19.9451C20.1837 12.9696 20.4171 13.0398 20.6162 13.1713C20.8154 13.3028 20.9715 13.4899 21.0652 13.7094L21.6589 15.0982C21.774 15.3674 21.8333 15.657 21.8333 15.9497V20.75C21.8333 21.0373 21.7192 21.3129 21.516 21.516C21.3129 21.7192 21.0373 21.8333 20.75 21.8333Z",
    stroke: "#0A4468",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 17.5C21.8333 17.2127 21.7192 16.9371 21.516 16.734C21.3129 16.5308 21.0373 16.4167 20.75 16.4167H13.1667C12.8793 16.4167 12.6038 16.5308 12.4006 16.734C12.1975 16.9371 12.0833 17.2127 12.0833 17.5",
    stroke: "#0A4468",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02083 9.91666H12.0833",
    stroke: "#0A4468",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02083 5.71875H15.3333",
    stroke: "#0A4468",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 6.44998C5.4732 6.44998 5.63028 6.40233 5.7639 6.31305C5.89751 6.22377 6.00165 6.09688 6.06315 5.94841C6.12465 5.79995 6.14074 5.63658 6.10939 5.47897C6.07804 5.32136 6.00066 5.17659 5.88702 5.06296C5.77339 4.94933 5.62862 4.87195 5.47101 4.8406C5.3134 4.80924 5.15004 4.82533 5.00157 4.88683C4.85311 4.94832 4.72621 5.05246 4.63693 5.18608C4.54765 5.31969 4.5 5.47678 4.5 5.63748C4.5 5.85297 4.5856 6.05963 4.73798 6.21201C4.89035 6.36438 5.09701 6.44998 5.3125 6.44998Z",
    fill: "#0A4468"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 10.7833C5.4732 10.7833 5.63028 10.7357 5.7639 10.6464C5.89751 10.5571 6.00165 10.4302 6.06315 10.2818C6.12465 10.1333 6.14074 9.96992 6.10939 9.81231C6.07804 9.6547 6.00066 9.50993 5.88702 9.3963C5.77339 9.28267 5.62862 9.20529 5.47101 9.17394C5.3134 9.14259 5.15004 9.15867 5.00157 9.22017C4.85311 9.28167 4.72621 9.38581 4.63693 9.51942C4.54765 9.65304 4.5 9.81013 4.5 9.97082C4.5 10.1863 4.5856 10.393 4.73798 10.5453C4.89035 10.6977 5.09701 10.7833 5.3125 10.7833Z",
    fill: "#0A4468"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 15.0084C5.4732 15.0084 5.63028 14.9607 5.7639 14.8714C5.89751 14.7821 6.00165 14.6553 6.06315 14.5068C6.12465 14.3583 6.14074 14.195 6.10939 14.0373C6.07804 13.8797 6.00066 13.735 5.88702 13.6213C5.77339 13.5077 5.62862 13.4303 5.47101 13.399C5.3134 13.3676 5.15004 13.3837 5.00157 13.4452C4.85311 13.5067 4.72621 13.6108 4.63693 13.7445C4.54765 13.8781 4.5 14.0352 4.5 14.1959C4.5 14.4113 4.5856 14.618 4.73798 14.7704C4.89035 14.9228 5.09701 15.0084 5.3125 15.0084Z",
    fill: "#0A4468"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.4d5fcdc59e7f278a5392a3d7aff473a6.svg";
export { ForwardRef as ReactComponent };